// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"83e3e2af","553":"6d202182","977":"2e1fb88e"}[chunkId] + ".chunk.js";
};